import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {Observable, Subject} from 'rxjs';
import {LicenseService} from '../../services/license.service';

import {LoadingPage} from '../../../shared/components/loading/loading.page.component';
import {EnvironmentService} from '../../services/environment.service';
import {CertificateService} from '../content/certificate/certificate.service';
import {ProfileService} from '../profile/profile.service';

declare var moment: any;

@Component({
  selector: 'itpx-class-preview',
  templateUrl: './class-preview.component.html',
  styleUrls: ['./class-preview.component.css']
})
export class ClassPreviewComponent extends LoadingPage {

  private images: string[];

  private class: Observable<any> = Observable.never();
  private tiles: Observable<any[]> = Observable.never<any[]>();
  private certificates: Array<any>;
  private name: string;

  constructor(private licenseService: LicenseService,
              private route: ActivatedRoute,
              private envService: EnvironmentService,
              private profileService: ProfileService,
              private certificateService: CertificateService) {
    super();
    this.images = this.envService.config['server'].images;
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      let classId = params['id'];
      this.loadCertificates(classId);
      this.loadClassAssignments(classId);
    });
  }

  private toTileData(assignment: any): any {
    let tile = {
      target: ['/app/course/', assignment.id],
      title: assignment.name,
      isExam: assignment.productVariant.product.type == 'Exam',
      imageUrl: assignment.productVariant.product.imageUrl,
      assignment: assignment,
      type: assignment.productVariant.product.type
    };

    return tile;
  }

  private loadCertificates(assignmentId: string) {
    this.certificateService.getCertificates(assignmentId)
      .subscribe(
        body => {
            this.certificates = body['data'].map(d => {return d});
        }
      );
  }

  private loadClassAssignments(classId: string) {
    this.class = this.licenseService.getClassAssignments(classId)
      .neverError()
      .map(body => body.data)
      .cacheResult();

    this.tiles = this.class
      .map(classEvent => classEvent.assignments.map(a => this.toTileData(a)));

    this.class.bindToLifecycle(this).subscribe(_ => this.ready());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/class/class-preview.component.ts